import { useAuth } from "../contexts/AuthContext";
import DashboardAdmin from "./dashboards/DashboardAdmin";
import DashboardGuard from "./dashboards/DashboardGuard";

/**
 * Role-aware `/` dashboard dispatcher.
 *
 * • Officers         → slim self-service card with CTA to /guard-portal
 * • Admin / Super  → full DashboardAdmin (all KPIs incl. MRR + revenue)
 * • Supervisor /
 *   Ops Manager /
 *   CSO            → same layout with admin-only KPI tiles filtered out via
 *                    dashboardPrefs.isKpiAllowedForRole
 *
 * Client-tier users never hit `/` (Protected → /portal), so no case needed.
 */
export default function Dashboard() {
  const { user } = useAuth();
  const role = user?.role || "admin";

  if (role === "guard") return <DashboardGuard />;
  return <DashboardAdmin role={role} />;
}
